export enum StockMode {
  NONE = 'none',
  TOGGLE = 'toggle',
  DISABLE_ONLY = 'disable_only',
  ENABLE_ONLY = 'enable_only',
}
